import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './GallectionLayout';
import { AppState } from '../../../../types/store';
import {
  getIsRootStashFolder,
  getSelectedFolder,
} from '../../../../selectors/studio';
import { copyFolderLink } from '../../../../actions/studio/folders';

export type StateProps = Pick<Props, 'folder' | 'isRootStashFolder'>;
export type DispatchProps = Pick<Props, 'copyFolderLink'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folder: getSelectedFolder(state)!,
  isRootStashFolder: getIsRootStashFolder(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  copyFolderLink,
};

export default connect(mapStateToProps, mapDispatchToProps);
